// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"00d11fd9","729":"e6bdbe35","770":"4939919e","918":"453c837d"}[chunkId] + ".chunk.js";
};